<template src="./YtdReport.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import reportApi from "@/api/reportApi";

export default defineComponent({
    data() {
        return {
            reportOutdated: false,
            reportDate: new Date()
        };
    },
    created() {
        reportApi.getYearToDateReportDatetime().then((response) => {
            this.reportDate = new Date(response.data.reportCreatedDateTime);
            const acceptableDate = new Date();
            acceptableDate.setDate(acceptableDate.getDate() - 2);
            this.reportOutdated =
                this.reportDate.getTime() < acceptableDate.getTime();
        });
    }
});
</script>

<style></style>
